export default "__VITE_ASSET__BopGnPV$__"